import FormSubmitted from './FormSubmitted';

export default FormSubmitted;
